import { useState } from "react";
import { SearchListCallbacks } from "../../GenericComponents/searchlistCallbacks";

export const approveUsersCallback = (userAttributesData: any, onSetSelectedItems: (data: any) => void): SearchListCallbacks => {

    const onFind = async (filterText: string) => {
        // If filterText is empty or null, return all items
        if (!filterText?.trim()) {
            return userAttributesData.map((item: { KeyValue: any; DisplayText: any; DisplayDesc:any }) => ({
                KeyValue: item.KeyValue,
                DisplayText: item.DisplayText,
                DisplayDesc: item.DisplayDesc,
            }));
        }

        // Filter the data based on the search text
        const filtered = userAttributesData.filter((item: any) =>
            item.DisplayText.toLowerCase().includes(filterText.toLowerCase())
        );

        if (filtered.length === 0) {
            return "Sorry, no matches found. Try a different search.";
        }

        return filtered.map((item: { KeyValue: any; DisplayText: any }) => ({
            KeyValue: item.KeyValue,
            DisplayText: item.DisplayText,
        }));
    };

    const onSave = async (selectedItems: any[]) => {
        onSetSelectedItems(selectedItems);
    }

    return {
        onFind,
        onSave,
    };
};










